import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../UI/Modal";
import UploadMediaForm from "../UploadMediaForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onUploadCompleted: () => void;
};

const UploadMediaModal: FC<Props> = ({
  isOpen,
  onClose,
  onUploadCompleted,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {t("components.screenMediaList.uploadMediaModal.title")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <UploadMediaForm onUploadCompleted={onUploadCompleted} />
      </ModalBody>
    </Modal>
  );
};

export default UploadMediaModal;
